import { Button, Form, Card, Pagination } from 'react-bootstrap';
import CompanyInfo from './CompanyInfo';
import { useEffect, useState } from 'react';
import { Search } from 'react-bootstrap-icons';

const Associations = ({ type = 'Mortgage Companies', companies, addCompany, updateCompany }) => {
  const [filteredCompanies, setFilteredCompanies] = useState(companies);
  const [add, setAdd] = useState(false);
  const [activePage, setActivePage] = useState(0);
  const [pageCount, setPageCount] = useState(Math.ceil(companies.length / 5));
  const [searchQuery, setSearchQuery] = useState('');
  const onCancel = () => setAdd(false);

  useEffect(() => setPageCount(Math.ceil(filteredCompanies.length / 5)), [filteredCompanies]);

  useEffect(() => {
    setFilteredCompanies(
      companies.filter(({ name, id }) => {
        if (name.toLowerCase().includes(searchQuery.toLowerCase())) return true;
        if (id.toString().includes(searchQuery)) return true;
        return false;
      })
    );
    setActivePage(0);
  }, [searchQuery, companies]);

  return (
    <Card className="association-container">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <Card.Title>
          <h3 className="display-6 fw-normal mb-3">{type}</h3>
        </Card.Title>
        <div className="d-flex">
          <Form.Group className="d-flex align-items-center" style={{ marginRight: '5px' }}>
            <Search />
            <Form.Control
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ marginLeft: '5px' }}
              placeholder="Search"
            />
          </Form.Group>
          {(type !== 'Tax Service' || (type === 'Tax Service' && !companies.length)) && (
            <Button
              className="dark-btn"
              aria-label="add-associated-company"
              onClick={() => setAdd(true)}
            >
              +
            </Button>
          )}
        </div>
      </Card.Header>
      <Card.Body>
        {add && (
          <CompanyInfo
            aLabel="add-company-form"
            _new
            onSubmit={(values) => {
              addCompany(values);
              setAdd(false);
            }}
            onCancel={onCancel}
          />
        )}
        {filteredCompanies.slice(activePage * 5, (activePage + 1) * 5).map((company, key) => (
          <CompanyInfo key={key} initialValues={company} onSubmit={updateCompany} index={key} />
        ))}
        <Pagination className="justify-content-center">
          <Pagination.First disabled={activePage === 0} onClick={() => setActivePage(0)} />
          <Pagination.Prev
            disabled={activePage === 0}
            onClick={() => setActivePage(activePage - 1)}
          />
          {Array.from(Array(pageCount).keys())
            .slice(activePage > 1 ? activePage - 1 : 0, activePage + 2)
            .map((number) => (
              <Pagination.Item
                active={number === activePage}
                onClick={() => setActivePage(number)}
                key={number}
              >
                {number + 1}
              </Pagination.Item>
            ))}
          <Pagination.Next
            disabled={activePage === pageCount - 1}
            onClick={() => setActivePage(activePage + 1)}
          />
          <Pagination.Last
            disabled={activePage === pageCount - 1}
            onClick={() => setActivePage(pageCount - 1)}
          />
        </Pagination>
      </Card.Body>
    </Card>
  );
};

export default Associations;
